import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import { QrcodeStream } from 'vue-qrcode-reader';

export default {
  name: 'InvestigationDetail',
  components: {
    TimeComp: require('../../../components/time.vue').default,
    QrcodeStream
  },
  props: ['dataObj'],
  data: function () {
    return {
      investigationData: { fullAddress: '', id: -1 },
      bPortalGis: false,
      element: { name: '' },
      mActivity: { name: '' },
      stations: [],
      serviceTypes: [],
      investigationReasons: [],
      maintenanceActivities: [],
      workflowEmployees: [],
      complainTypes: [],
      elementTypes: [],
      outcomeTypes: [],
      bEnableProblemFound: false,
      bEnableNoFurtherProc: false,
      bGPSFiltering: false,
      bShowWarningWFEmployee: false,
      bChangeWorkflowEmployee: false,
      bQrCodeScan: false,
      newStationId: -1,
      newWorkflowEmployeeId: -1,
      newWorkflowEmployee: { name:'' },
      newComment: '',
      message: '',
      options: { pageSize: 1000, total: 0, page: 1 },
      selectedReportId: -1,
      reports: [],
      value: '',
      geoLocation: null,
      elements: [],
      disabledDates: date => {
        var bDoNotAllow = this.investigationData ? this.investigationData.isReadOnly : false;
        return bDoNotAllow === true ? bDoNotAllow : date > new Date();
      },
      timeFrom: { hours: 0, minutes: 0, descr: 'investigationDetail.TimeFrom', isReadOnly: false },
      timeTo: { hours: 0, minutes: 0, descr: 'investigationDetail.TimeTo', isReadOnly: false },
    }
  },
  computed: {
    investigationId: function () {
      return this.investigationData.id;
    },
    mActivityId: function () {
      return this.investigationData.mActivityId;
    },
    outcomeTypeId: function () {
      return this.investigationData.outcomeTypeId;
    },
    elementTypeId: function () {
      return this.investigationData.elementTypeId;
    },
    complainTypeId: function () {
      return this.investigationData.complainTypeId;
    },
    timeFromHours: function () {
      return this.timeFrom.hours;
    },
    timeFromMinutes: function () {
      return this.timeFrom.minutes;
    },
    timeToHours: function () {
      return this.timeTo.hours;
    },
    timeToMinutes: function () {
      return this.timeTo.minutes;
    },
  },
  watch: {
    newStationId: function (value) {
      this.getWorkflowEmployees();
    },
    newWorkflowEmployee: function (value) {
      this.newWorkflowEmployeeId = value ? value.id : -1;
      this.$refs.selectEmployee.open = false;
    },
    complainTypeId: function (value) {
      if (value > -1)
        this.getMaintenanceActivities();
    },
    mActivityId: function (value) {
      this.getElementTypes();
    },
    outcomeTypeId: function (value) {
      this.bEnableProblemFound = (value === 1); //ProblemFound
      this.bEnableNoFurtherProc = (value === 2); //NoFurtherProcessingRequired
      this.investigationData.investigationReasonId = (value !== 2) ? -1: this.investigationData.investigationReasonId;
    },
    elementTypeId: function (value) {
      this.getElements();
    },
    element: function (value) {
      this.investigationData.elementId = value? value.id: -1;
      this.$refs.select.open = false;
    },
    mActivity: function (value) {
      this.investigationData.mActivityId = value ? value.id : -1;
      this.$refs.selectMActivity.open = false;
    },
    timeFromHours: function (value) {
      this.investigationData.dateFromHH = value;
      this.$root.$emit('investigation_or_jobcard_updated');
    },
    timeFromMinutes: function (value) {
      this.investigationData.dateFromMin = value;
      this.$root.$emit('investigation_or_jobcard_updated');
    },
    timeToHours: function (value) {
      this.investigationData.dateToHH = value;
    },
    timeToMinutes: function (value) {
      this.investigationData.dateToMin = value;
    },
    bGPSFiltering: function (val) {
      this.getElements();
      if (this.$refs.select)
        this.$refs.select.open = false;
    },
    investigationId: function (value) {
      if (value <= 0)
        return;
      this.investigationData = this.dataObj;
      this.investigationData.assignedEmployee = this.investigationData.workflowEmployeeId > 0 ? this.getAssignedWorkflowEmployeeText() : 'Unknown';
      this.investigationData.fullAddress = this.investigationData.physicalAddress + ', ' + this.investigationData.town + ', ' + this.investigationData.township;

      this.timeFrom.hours = this.investigationData.dateFromHH;
      this.timeFrom.minutes = this.investigationData.dateFromMin;
      this.timeFrom.isReadOnly = this.investigationData.isReadOnly;
      this.timeTo.hours = this.investigationData.dateToHH;
      this.timeTo.minutes = this.investigationData.dateToMin;
      this.timeTo.isReadOnly = this.investigationData.isReadOnly;

      this.getStations();
      this.getInvestigationReasons();
      this.getServiceTypes();
      this.getComplainTypes();
      this.getOutcomeTypes();
      this.getWorkflowEmployees();

      this.investigationData.fullAddress = this.investigationData.physicalAddress;
      this.investigationData.fullAddress = (this.investigationData.town && this.investigationData.town.length > 0) ? this.investigationData.fullAddress + ', ' + this.investigationData.town : this.investigationData.fullAddress;
      this.investigationData.fullAddress = (this.investigationData.township && this.investigationData.township.length > 0) ? this.investigationData.fullAddress + ', ' + this.investigationData.township : this.investigationData.fullAddress;
      this.getElementTypes();
      this.getProfileDetails();
      this.getInvestigationReports();

      this.getElement();
    }
  },
  created() {
    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );

    this.init();
    this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        if (this.dataObj.id > 0)
          this.investigationData = this.dataObj;
      });
    },
    setInvestigationWorkflowEmployee() {
      if (this.newWorkflowEmployeeId <= 0) {
        this.bShowWarningWFEmployee = true;
        return;
      }
      axios.post('/Om/SetInvestigationWorkflowEmployee',
        {
          ObjectId: this.investigationData.id,
          EmployeeId: this.newWorkflowEmployeeId,
          Comment: this.newComment
        })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.NewEmployeeAssignedSuccess'), 2);
            this.bChangeWorkflowEmployee = false;
            this.investigationData.workflowEmployeeId = this.newWorkflowEmployeeId;
            this.investigationData.assignedEmployee = this.investigationData.workflowEmployeeId > 0 ? this.getAssignedWorkflowEmployeeText() : 'Unknown';
          }
          else
            this.$alertMsg(response.data.data.text)
        })
        .catch((e) => {
          console.log('setInvestigationWorkflowEmployee');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    cancelNewEmployee() {
      this.bChangeWorkflowEmployee = false;
    },
    getAssignedWorkflowEmployeeText() {
      var assignedEmployee = this.workflowEmployees.filter(t => t.id == this.investigationData.workflowEmployeeId).length > 0 ? this.workflowEmployees.filter(t => t.id == this.investigationData.workflowEmployeeId)[0] : null;
      return assignedEmployee !== null ? assignedEmployee.name : 'Unknown Employee';
    },
    getProfileDetails() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          //add flag for field worker user
          //this.user['isFieldWorker'] = response.data.item.isFieldWorker;

          if (response.data.data.status == 0)
            this.bPortalGis = (response.data.item.portalGis && response.data.item.portalGis == true) ? true : false;
        })
        .catch(e => {
          console.log('getProfileDetails');
          console.log(e);
          this.$parent.user.authenticated = false;
          this.$router.push('/login');
        })
    },
    getServiceTypes() {
      axios.post('/Om/GetServiceTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.serviceTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getServiceTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getInvestigationReasons() {
      axios.post('/Om/GetInvestigationReasons')
        .then(response => {
          if (response.data.data.status == 0) {
            this.investigationReasons = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getInvestigationReasons');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getOutcomeTypes() {
      axios.post('/Om/GetInvestigationLookup')
        .then(response => {
          if (response.data.data.status == 0) {
            this.outcomeTypes = response.data.outcomeTypes;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getOutcomeTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getStations() {
      axios.post('/Om/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getStations');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getInvestigationReports() {
      axios.get('/Om/GetInvestigationReports')
        .then(response => {
          var items = response.data.items;
          if (items.length > 1)
            items.unshift({ reportId: -1, description: 'Select report' });
          this.reports = items;
          if (this.reports.length > 0)
            this.selectedReportId = this.reports[0].reportId;
        })
        .catch(e => {
          console.log('getInvestigationReports');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    createInvestigationReport() {
      if (this.selectedReportId > 0) {
        var parameters = { ReportId: this.selectedReportId, ObjectId: this.investigationData.id };
        axios.post('/Om/CreateInvestigationReport', parameters)
          .then(response => {
            if (response.data.data.status == 0) {
              var url = response.data.url;
              window.open(url, '_blank');
            }
            else
              this.$alertMsg(response.data.data.text, 1)
          })
          .catch(e => {
            console.log('createInvestigationReport');
            console.log(e);
            this.$alertMsg(e.message, 1)
          })
      }
    },
    getMaintenanceActivities() {
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetMaintenanceActivities', { Value: this.investigationData.complainTypeId }),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.maintenanceActivities = response.data.items;
            this.mActivity = this.maintenanceActivities.filter(t => t.id == this.investigationData.mActivityId)[0];
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        },
        err => {
          console.log('getMaintenanceActivities');
          console.log(err);
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Details'
      );
    },
    getElement() {
      axios.post('/Om/GetElement', { TypeId: this.investigationData.elementTypeId, Id: this.investigationData.elementId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.element = response.data.item;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElement');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getElements() {
      var parameter = {
        FilterByCurrentLocation: false,
        ElementTypeId: this.investigationData.elementTypeId,
        CoordLat: 0,
        CoordLong: 0,
        CoordAccuracy: 0,
        ListOptions: this.options
      };
      if (this.geoLocation != null) {
        parameter.FilterByCurrentLocation = this.bGPSFiltering;
        parameter.CoordLat = this.geoLocation.coords.latitude;
        parameter.CoordLong = this.geoLocation.coords.longitude;
        parameter.CoordAccuracy = this.geoLocation.coords.accuracy;
      }
      axios.post('/Element/GetElements', parameter)
        .then(response => {
          if (response.status == 200) {
            this.elements = response.data.items;
            this.options.count = response.data.count;
            var element = this.elements.filter(t => t.id === this.investigationData.elementId)[0];
            if (element)
              this.value = element.name;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getElements');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getGisLayerName() {
      var res = this.elementTypes.filter(t => t.typeId == this.investigationData.elementTypeId);
      return (res.length == 1) ? res[0].gisLayerName : "";
    },
    getElementTypes() {
      var mActivity = this.maintenanceActivities.filter(t => t.id == this.investigationData.mActivityId)[0];
      this.elementTypes = (mActivity) ? this.$store.state.elementTypesPlain.filter(t => t.typeId == mActivity.elementTypeId) : this.$store.state.elementTypesPlain;

      /*axios.get('/Element/GetElementTypesPlain')
        .then(response => {
          if (response.status == 200) {
            var mActivity = this.maintenanceActivities.filter(t => t.id == this.investigationData.mActivityId)[0];
            this.elementTypes = (mActivity) ? response.data.items.filter(t => t.typeId == mActivity.elementTypeId) : response.data.items;
          }
          else {
            this.$alertMsg(response.data)
          }
        })
        .catch(e => {
          console.log('getElementTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })*/
    },
    getComplainTypes() {
      axios.post('/Om/GetComplainTypes')
        .then(response => {
          if (response.data.data.status == 0) {
            this.complainTypes = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getComplainTypes');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getWorkflowEmployees() {
      axios.post('/Om/GetWorkflowEmployees', { Value: this.newStationId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.workflowEmployees = response.data.items;
            this.investigationData.assignedEmployee = this.investigationData.workflowEmployeeId > 0 ? this.getAssignedWorkflowEmployeeText() : 'Unknown';
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getWorkflowEmployees');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getElementFromQR(qrElementId) {
      axios.post('/Om/GetElement', { TypeId: this.investigationData.elementTypeId, Id: qrElementId })
        .then(response => {
          if (response.data.data.status == 0) {
            this.element = response.data.item;
            this.$alertMsg(this.$t('messages.QRCodeElementSetSuccess'), 2);
          }
          else {
            this.$alertMsg(this.$t('messages.QRCodeElementFailure'))
          }
        })
        .catch(e => {
          console.log('getElementFromQR');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    onDecode(content) {
      this.bQrCodeScan = false;
      this.getElementFromQR(parseInt(content));
    },
    onInit(promise) {
      promise.then(() => {
        console.log('QR Reader Successfully initilized! Ready for scanning now!')
      })
        .catch(error => {
          if (error.name === 'NotAllowedError') {
            this.errorMessage = 'Hey! I need access to your camera'
          } else if (error.name === 'NotFoundError') {
            this.errorMessage = 'Do you even have a camera on your device?'
          } else if (error.name === 'NotSupportedError') {
            this.errorMessage = 'Seems like this page is served in non-secure context (HTTPS, localhost or file://)'
          } else if (error.name === 'NotReadableError') {
            this.errorMessage = 'Couldn\'t access your camera. Is it already in use?'
          } else if (error.name === 'OverconstrainedError') {
            this.errorMessage = 'Constraints don\'t match any installed camera. Did you asked for the front camera although there is none?'
          } else {
            this.errorMessage = 'UNKNOWN ERROR: ' + error.message
          }
        })
    },
    zoomToElement() {
      axios.post('/GIS/GetZoomToElementUrl', { ElementType: this.element.typeId, ElementId: this.element.id })
        .then(response => {
          if (response.data.data.status == 0) {
            var url = response.data.url;
            window.open(url, '_blank');
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('zoomToElement');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    //zoomToElement() {
    //  var route = this.$router.resolve({ name: 'gis', params: { command: 'zoomToElement', param: { type: this.element.typeId, id: this.element.id, clearAll: true } } });
    //  window.open(route.href, '_blank');
    //},
  }

}
